import styled from 'styled-components';
import { spacing } from '_utils/props';
import { text_l } from '_utils/styles';
import { handleSectionTheme } from '_utils/styles/section';


export const Container = styled.div<{ $sectionTheme?: string; $hasPaddingTop?: boolean }>`
  width: 100%;
  ${({ $sectionTheme }) => handleSectionTheme($sectionTheme)}
  ${({ theme, $hasPaddingTop }) =>
    $hasPaddingTop ? spacing({ theme, $py: 7 }) : spacing({ theme, $pb: 7 })};
`;

export const Description = styled.p`
  ${text_l}
  margin: 0;
`;
